<template>
  <div id="index" ref="appRef">
    <div class="bg">
      <dv-loading v-if="loading">Loading...</dv-loading>
      <div v-else class="host-body">
        <div class="d-flex jc-center">
          <dv-decoration-10 class="dv-dec-10" />
          <div class="d-flex jc-center">
            <dv-decoration-8 class="dv-dec-8" :color="decorationColor" />
            <div class="title">
              <span class="title-text">大数据可视化平台</span>
              <dv-decoration-6 class="dv-dec-6" :reverse="true" :color="['#50e3c2', '#67a1e5']" />
            </div>
            <dv-decoration-8 class="dv-dec-8" :reverse="true" :color="decorationColor" />
          </div>
          <dv-decoration-10 class="dv-dec-10-s" />
        </div>

        <!-- 第二行 -->
        <div class="d-flex jc-between px-2">
          <div class="d-flex aside-width">
            <div class="react-left ml-4 react-l-s">
              <span class="react-left"></span>
              <span class="text">亿伟林洋QDF大数据可视化平台</span>
            </div>
            <div class="react-left ml-3">
              <span class="text">AGV数据</span>
            </div>
          </div>
          <div class="d-flex aside-width">
            <div class="react-right bg-color-blue mr-3">
              <span class="text fw-b">正极对接车间</span>
            </div>
            <div class="react-right mr-4 react-l-s">
              <span class="react-after"></span>
              <span class="text">{{ dateYear }} {{ dateWeek }} {{ dateDay }}</span>
            </div>
          </div>
        </div>

        <div class="body-box">
          <!-- 第三行数据 -->
          <div class="content-box">
            <div>
              <dv-border-box-12>
                <centerLeft1 />
              </dv-border-box-12>
            </div>
            <div class="abs" v-for="list in titleItemList" :key="list">
              <dv-border-box-12>
                <!-- <centerLeft2 /> -->
                <div class="up">
                  <div class="bg-color-black item" v-for="item in list" :key="item.title">
                    <div v-if="item.code">
                      <p class="ml-3 colorBlue fw-b fs-xl titleSize">{{ item.code }}</p>
                      <div>
                        <p class="dv-dig-flop ml-1 mt-2 pl-3 bodyclass">{{ item.text }}</p>
                      </div>
                    </div>
                    <div v-else-if="item.img">
                      <div>
                        <img src="@/assets/AGV.png" width="50%" height="50%">
                      </div>
                    </div>
                    <div v-else>
                      <p class="ml-3 colorBlue fw-b fs-xl titleSize">{{ item.title }}</p>
                      <div>
                        <p class="dv-dig-flop ml-1 mt-2 pl-3 bodyclass">{{ item.text }}</p>
                      </div>
                    </div>
                  </div>
                </div>
              </dv-border-box-12>
            </div>
            <div>
              <dv-border-box-13>
                <div class="up">
                  <div class="bg-color-black item" v-for="item in bodyList" :key="item.title">
                    <div v-if="item.code">
                      <p class="ml-3 colorBlue fw-b fs-xl titleSize">{{ item.code }}</p>
                      <div>
                        <p class="dv-dig-flop ml-1 mt-2 pl-3 bSize">{{ item.text }}</p>
                      </div>
                    </div>
                    <div v-else-if="item.img">
                      <div>
                        <img src="@/assets/tsj.png" width="50%" height="50%">
                      </div>
                    </div>
                    <div v-else>
                      <p class="ml-3 colorBlue fw-b fs-xl titleSize">{{ item.title }}</p>
                      <div>
                        <p class="dv-dig-flop ml-1 mt-2 pl-3 bclass">{{ item.text }}</p>
                      </div>
                    </div>
                  </div>
                </div>
              </dv-border-box-13>
            </div>
            <!-- 中间 -->
            <!-- <div>
              <center />
            </div> -->
            <!-- 中间 -->
            <!-- <div>
              <centerRight2 />
            </div> -->
            <!-- <div>
              <dv-border-box-13>
                <centerRight1 />
              </dv-border-box-13>
            </div> -->
          </div>

          <!-- 第四行数据 -->
          <div class="bottom-box">
            <dv-border-box-13>
              <bottomLeft />
            </dv-border-box-13>
            <dv-border-box-12>
              <bottomRight />
            </dv-border-box-12>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import drawMixin from "../utils/drawMixin";
import { formatTime } from '../utils/index.js'
import centerLeft1 from './centerLeft1'
// import centerLeft2 from './centerLeft2'
// import centerRight1 from './centerRight1'
// import centerRight2 from './centerRight2'
// import center from './center'
import bottomLeft from './bottomLeft'
import bottomRight from './bottomRight'
import axios from 'axios';

export default {
  mixins: [drawMixin],
  data() {
    return {
      timing: null,
      loading: true,
      dateDay: null,
      dateYear: null,
      dateWeek: null,
      weekday: ['周日', '周一', '周二', '周三', '周四', '周五', '周六'],
      decorationColor: ['#568aea', '#000000'],
      titleItem: [],
      titleItemList: [],
      bodyList: [
        {
          code: '提升机编号',
          text: "正箔材提升机"
        },
        {
          img: '图片',
          imgs: "D:/Git/YaoNeng/项目代码/big-screen-vue-datav/src/assets/logo.png"

        },

        // {
        //   title: '当前地标',
        //   text: "222"
        // },
        // {
        //   title: '当前速度',
        //   text: "333"
        // },
        {
          title: 'AGV报警',
          text: "未连接"
        },
        {
          title: '提升机报警',
          text: "未连接"
        },
        {
          title: 'AGV对接反馈',
          text: "未连接"
        },
        {
          title: '提升机对接反馈',
          text: "未连接"
        },
        {
          title: '提升机运行状态',
          text: "未连接"
        }
      ],
      frequency: 0
    }
  },
  components: {
    centerLeft1,
    // centerLeft2,
    // centerRight1,
    // centerRight2,
    // center,
    bottomLeft,
    bottomRight
  },
  mounted() {
    this.timeFn()
    this.cancelLoading()
    this.changeTiming()
    this.changeTiming1()
  },
  beforeDestroy() {
    clearInterval(this.timing)
  },
  methods: {
    timeFn() {
      this.timing = setInterval(() => {
        this.dateDay = formatTime(new Date(), 'HH: mm: ss')
        this.dateYear = formatTime(new Date(), 'yyyy-MM-dd')
        this.dateWeek = this.weekday[new Date().getDay()]
      }, 1000)
    },
    changeTiming() {
      this.GetAGVStatus()
      setInterval(() => {
        this.GetAGVStatus()
      }, 3000)
    },
    changeTiming1() {
      this.GetTSJStatus()
      setInterval(() => {
        this.GetTSJStatus()
      }, 20000)
    },
    GetAGVStatus() {
      axios.post("http://192.168.11.58:8098/api/ToWMS/GetAgvStatusData", {
        // axios.post("http://127.0.0.1:8098/api/ToWMS/GetAgvStatusData", {
        MainData: {
          AGVName: "正极AGV调度"
        }
      }).then((res) => {
        if (res.data.status) {
          let agvs = res.data.data
          let count = agvs.length
          let agvdata = []
          if (count <= 5) {
            agvdata = agvs
          }
          else {
            if (this.frequency == 0) {
              for (let index = 0; index < count; index++) {
                if (index < 5) {
                  agvdata.push(agvs[index])
                }
              }
              this.frequency = 1;
            }
            else if (this.frequency == 1) {
              for (let index = 0; index < count; index++) {
                if (index >4 && index <= 9) {
                  agvdata.push(agvs[index])
                }
              }
              this.frequency++;
            }
            else if (this.frequency == 2) {
              for (let index = 0; index < count; index++) {
                if (index >9 && index <= 14) {
                  agvdata.push(agvs[index])
                }
              }
              this.frequency++;
            } else if (this.frequency == 3) {
              for (let index = 0; index < count; index++) {
                if (index >14 && index <= 19) {
                  agvdata.push(agvs[index])
                }
              }
              this.frequency++;
            } else if (this.frequency == 4) {
              for (let index = 0; index < count; index++) {
                if (index >19 && index <= 24) {
                  agvdata.push(agvs[index])
                }
              }
              this.frequency = 0;
            }
          }
          console.log("🚀 ~ file: index.vue:236 ~ GetAGVStatus ~ agvs:", agvs)
          let sss = [];
          agvdata.forEach(element => {
            let titleItem = []
            titleItem = [
              {
                code: 'AGV编号',
                text: element.agvCode + "  号车"
              },
              {
                img: '图片',
                imgs: "D:/Git/YaoNeng/项目代码/big-screen-vue-datav/src/assets/logo.png"
              },
              {
                title: '运行状态',
                text: element.agvStatus == 0 ? "停  止" : element.agvStatus == 1 ? "行  驶" : "暂  停"
              },
              {
                title: '当前地标',
                text: element.agvRfidLabel
              },
              {
                title: '当前速度',
                text: element.agvSpeed + "  mm/s"
              },
              {
                title: 'AGV类型',
                text: element.agvType == 0 ? "潜伏型" : element.agvType == 1 ? "牵引型" : element.agvType == 2 ? "承载型" : element.agvType == 3 ? "举升型" : element.agvType == 4 ? "辊道型" : element.agvType == 5 ? "叉车型" : "其他"
              },
              {
                title: 'AGV上下线状态',
                text: element.agvOnline
              },
              {
                title: 'AGV报警代码',
                text: element.agvAlarmCode
              }
            ]
            sss.push(titleItem)
          });
          this.titleItemList = [];
          this.titleItemList = sss;
        }
      }).catch((res) => {
        console.log(res)
      })
    },
    GetTSJStatus() {
      axios.post("http://192.168.11.58:8098/api/ToWMS/GetTSJInfo", {
        // axios.post("http://127.0.0.1:8098/api/ToWMS/GetTSJInfo", {
        MainData: {
          TSJName: "正极箔材提升机"
        }
      }).then((res) => {
        if (res.data.status) {
          let agvs = res.data.data
          console.log(agvs);
          this.bodyList = [];
          let titleItem = [
            {
              code: '提升机编号',
              text: '正极箔材提升机'
            },
            {
              img: '图片',
              imgs: "E:/宽海/项目集/宽海项目/冠鸿智能/亿伟林洋QDF/大屏/big-screen-vue-datav/src/assets/logo.png"
            },

            {
              title: 'AGV报警',
              text: agvs.agverror == 0 ? "无报警" : agvs.agverror == 1 ? "报警" : "异常"
            },
            {
              title: '提升机报警',
              text: agvs.tsjerror == false ? "无报警" : agvs.tsjerror == true ? "报警" : agvs.tsjerror
            },

            {
              title: 'AGV步骤反馈',
              text: agvs.error
            },
            {
              title: '提升机步骤反馈',
              text: agvs.floor
            },
            {
              title: '提升机工作状态',
              // text: agvs.status == 0 ? "停  止" : agvs.agvStatus == 1 ? "行  驶" : "暂  停"
              text: agvs.status
            }

          ]
          this.bodyList = titleItem;
        }
      }).catch((res) => {
        console.log(res)
      })
    },
    cancelLoading() {
      setTimeout(() => {
        this.loading = false
      }, 500)
    }
  }
}
</script>

<style lang="scss" scoped>
@import '../assets/scss/index.scss';

.bg-color-black {
  border-radius: 5px;
}

.up {
  width: 100%;
  display: flex;
  flex-wrap: wrap;
  justify-content: space-around;

  .item {
    border-radius: 6px;
    padding-top: 8px;
    margin-top: 8px;
    width: 50%;
    height: 70px;

    .dv-dig-flop {
      width: 150px;
      height: 30px;
    }
  }

  .bodyclass {
    font-size: 26px;
    color: #24ebb9;
  }

  .bclass {
    font-size: 26px;
    color: #e0c218;
  }

  .titleSize {
    font-size: 16px;
  }

  .bSize {
    font-size: 20px;
    color: #e0c218;
  }
}
</style>
